<template>
  <v-app>
    <v-toolbar color="primary">
      <router-link to="/" class="pt-2">
        <img src="@/assets/citi.png" width="160">
      </router-link>
      <v-spacer></v-spacer>
      <v-menu offset-y>
        <v-btn slot="activator" dark flat icon>
          <v-badge color="secondary lighten-1" right overlap class="mt-1">
            <span slot="badge" dark small v-text="notifications.length"></span>
            <v-icon color="white">mail</v-icon>
          </v-badge>
        </v-btn>
        <v-list>
          <v-list-tile
            v-for="(notification, index) in notifications"
            :key="index"
            @click="gotoLink(index, notification.url)"
            class="mb-2"
          >
            <v-list-tile-content>
              <!-- <h4
                  v-text="notification.from"
              class="font-weight-light"></h4>-->
              <h4 v-text="notification.message" class="font-weight-regular"></h4>
              <v-divider></v-divider>
            </v-list-tile-content>
            <!-- <router-link :to="notification.url" class="secondary--text">
            </router-link>-->
          </v-list-tile>
        </v-list>
      </v-menu>
      <v-toolbar-items>
        <v-flex class="justify flex">
          <v-menu offset-y>
            <v-btn slot="activator" flat small>
              <span v-if="$vuetify.breakpoint.smAndUp">Welcome,&nbsp;</span>
              {{firstname}}
              <v-icon dark>arrow_drop_down</v-icon>
            </v-btn>
            <v-list>
              <v-list-tile @click="logout()">
                <v-list-tile-title>Logout</v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
        </v-flex>
      </v-toolbar-items>
    </v-toolbar>

    <v-content class="my-5">
      <slot/>
      <notification-bar></notification-bar>
    </v-content>
  </v-app>
</template>
<style>
.v-toolbar__items div {
  height: 100%;
  color: rgb(228, 228, 217);
}
</style>
<script>
import { AUTH_LOGOUT } from "@/store/actions/auth";
import {
  CLEAR_NOTIFICATION,
  CLEAR_ALL_NOTIFICATIONS
} from "@/store/actions/common";
import NotificationBar from "./notification";

export default {
  name: "AppLayout",
  components: { NotificationBar },
  data() {
    return {
      menuItems: [{ title: "Logout" }]
    };
  },
  computed: {
    firstname() {
      return this.$store.getters.getProfile.first_name;
    },
    notifications() {
      return this.$store.state.common.notifications;
    }
  },
  methods: {
    logout() {
      return this.$store
        .dispatch(AUTH_LOGOUT)
        .then(() => this.$router.push("/"));
    },
    gotoLink(index, url) {
      // add @hide or close to v-menu to clear all notifications
      this.$router.push(url);
      this.$store.dispatch(CLEAR_NOTIFICATION, index);
    }
  }
};
</script>


<style scoped>
a {
  text-decoration: none;
}
</style>
